import { Component, inject, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { TabsModule } from 'primeng/tabs';
import { SharedService } from '../shared.service';
import { BolsaInstituicaoCursoListItemDTO } from '../../../api/models/bolsaInstituicaoCursoListItemDTO';
import { EnumEstadoMatricula } from '../../../api/models/enumEstadoMatricula';
import { EnumParecerSolicitacao } from '../../../api/models/enumParecerSolicitacao';
import { MatriculaListItemDTO } from '../../../api/models/matriculaListItemDTO';
import { TipoAnexoRenovacaoService } from '../../../api/services/tipoAnexoRenovacao.service';
import { EnumEstadoBolsaCurso } from '../../../api/models/enumEstadoBolsaCurso';
import {
  BolsaInstituicaoCursoService,
  EnumService,
  MatriculaService,
  SolicitacaoRenovacaoService,
  InstituicaoEnsinoService,
  BolsaService,
  InstituicaoGestoraService,
} from '../../../api/services';
import {
  FormsModule,
  ReactiveFormsModule,
  FormBuilder,
  FormGroup,
} from '@angular/forms';
import { MessageService } from 'primeng/api';
import { EstadoSolicitacaoRenovacao } from '../../../api/models/estadoSolicitacaoRenovacao';
import { DataVoidComponent } from '@app/shared/components/data-void/data-void.component';
import {
  TableComponent,
  TableColumn,
} from '@app/shared/components/table/table.component';
import { DropdownModule } from 'primeng/dropdown';
import { PaginatorControlComponent } from '@app/shared/components/paginator-control/paginator-control.component';
import { Pagination } from '../../../../../../shared/model/pagination.model';
import { ApiService } from '@core/providers/http';
import { SearchBarComponent } from '@app/shared/components/search-bar/search-bar.component';
import { FilterItem } from '../../../api/models/filterItem.model';
import { DialogModule } from 'primeng/dialog';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { SelectModule } from 'primeng/select';
import { InputText } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';

interface FileItem {
  tipoAnexoRenovacaoID: number;
  descricao: string;
  required: boolean;
  file?: File;
}

@Component({
  selector: 'app-renovacao',
  imports: [
    TabsModule,
    CommonModule,
    ReactiveFormsModule,
    InputText,
    FormsModule,
    ConfirmDialogModule,
    DialogModule,
    ToastModule,
    SelectModule,
    ButtonModule,
    DataVoidComponent,
    TableComponent,
    DropdownModule,
    PaginatorControlComponent,
    SearchBarComponent,
  ],
  providers: [
    MessageService,
    ApiService,
    SolicitacaoRenovacaoService,
    InstituicaoEnsinoService,
    EnumService,
    BolsaInstituicaoCursoService,
    MatriculaService,
    TipoAnexoRenovacaoService,
    InstituicaoGestoraService,
  ],
  templateUrl: './renovacao.component.html',
  styleUrl: './renovacao.component.scss',
  standalone: true,
})
export class RenovacaoComponent implements OnInit {
  @Input() idBolsa!: number; // Recebe o id da bolsa como input

  solicitacaoRenovacaoService = inject(SolicitacaoRenovacaoService);
  messageService = inject(MessageService);

  enumService = inject(EnumService);
  bolsaInstCursoService = inject(BolsaInstituicaoCursoService);
  matriculaService = inject(MatriculaService);
  tipoAenexoRenovacaoService = inject(TipoAnexoRenovacaoService);
  instituicaoEnsinoService = inject(InstituicaoEnsinoService);
  instituicaoGestoraService = inject(InstituicaoGestoraService);

  bolsaInstCursoRenovar: BolsaInstituicaoCursoListItemDTO | undefined;
  matricula: MatriculaListItemDTO | undefined;
  listaEstados: { id: number; designacao: string }[] = [];
  listaAnexos: FileItem[] = [];
  estadoMatricula: any;
  valorRecebido: string = '';
  ViewDetails = false;
  showFilter = false;
  form!: FormGroup;

  // Para tabela de solicitações de renovação:
  solicitacoes: any[] = [];
  solicitacoesPagination: Pagination<any> = new Pagination<any>();
  solicitacoesLoading = false;

  solicitacoesColumns: TableColumn[] = [
    {
      field: 'AnoLetivoAtivacao.ano',
      header: 'Ano Letivo Activação',
      type: 'text',
    },
    {
      field: 'AnoLetivoAnterior.ano',
      header: 'Ano Letivo Anterior',
      type: 'text',
    },
    {
      field: 'ParecerInstituicaoDescricao',
      header: 'Parecer Instituição',
      type: 'text',
    },
    { field: 'Data', header: 'Data', type: 'text' },
  ];

  solicitacoesActions = [
    {
      label: 'Ver Detalhes',
      icon: 'pi pi-eye',
      command: (event: any) => this.verDetalhesSolicitacao(event.item),
    },
    {
      label: 'Validar',
      icon: 'pi pi-check',
      command: (event: any) => this.validarSolicitacao(event.item),
    },
  ];

  // Filtros
  filtroInstituicaoEnsino: number | null = null;
  filtroEmpresaGestora: number | null = null;
  instituicoesEnsino: { id: number; nome: string }[] = [];
  empresasGestoras: { id: number; nome: string }[] = [];

  ShowDetails = true;
  ShowRenovar = false;

  filters: FilterItem[] = [
    // {
    //   type: 'text',
    //   controlName: 'BolseiroID',
    //   placeholder: 'Pesquise por nome',
    // },
    {
      type: 'dropdown',
      controlName: 'InstituicaoEnsinoID',
      placeholder: 'Instituição de Ensino',
      options: this.instituicoesEnsino,
      optionLabel: 'nome',
      optionValue: 'id',
    },
    {
      type: 'dropdown',
      controlName: 'InstituicaoGestoraID',
      placeholder: 'Instituição Gestora',
      options: this.empresasGestoras,
      optionLabel: 'nome',
      optionValue: 'id',
    },
    {
      type: 'dropdown',
      controlName: 'Estado',
      placeholder: 'Estado da Solicitação',
      options: this.listaEstados,
      optionLabel: 'designacao',
      optionValue: 'id',
    },
  ];

  constructor(
    private router: Router,
    private activated: ActivatedRoute,
    private sharedService: SharedService,
    private fb: FormBuilder,
  ) {}

  ngOnInit() {
    this.sharedService.valorAtual.subscribe((valor) => {
      this.valorRecebido = valor;
    });

    this.getEstadoMatriculaEnum();
    this.getTipoAnexoRenovacao();
    this.getInstituicoesEnsino();
    this.getEmpresasGestoras();

    // Prioridade para input, fallback para rota
    let id = this.idBolsa ?? this.activated.snapshot.params['id'];
    if (id) {
      this.idBolsa = +id;
      // this.getBolsaInstituicaoCurso(this.idBolsa);
      this.carregarSolicitacoesRenovacao();
    }

    this.form = this.fb.group({
      InstituicaoEnsinoID: [null],
      InstituicaoGestoraID: [null],
      Estado: [null],
    });
  }

  handleFormValueChange(event: any) {
    const filters = Object.fromEntries(
      Object.entries(event).filter(
        ([_, value]) => value !== null && value !== undefined && value !== '',
      ),
    );
    this.carregarSolicitacoesRenovacao(filters);
    this.showFilter = false;
  }

  // --- Tabela de Solicitações de Renovação ---
  carregarSolicitacoesRenovacao(params: any = {}) {
    this.solicitacoesLoading = true;
    const queryParams = {
      ...params,
      pageNumber: this.solicitacoesPagination.pageNumber ?? 1,
      pageSize: this.solicitacoesPagination.pageSize ?? 5,
      BolsaID: this.idBolsa,
      OrderBy: 'id desc',
    };
    // Adapte para o seu endpoint real para buscar as solicitações de renovação
    this.solicitacaoRenovacaoService.list(queryParams).subscribe(
      (resp) => {
        this.solicitacoesPagination = new Pagination<any>().deserialize(resp);
        console.log(this.solicitacoesPagination);

        this.solicitacoesLoading = false;
      },
      () => (this.solicitacoesLoading = false),
    );
  }

  onSolicitacoesPageChange(event: any) {
    this.solicitacoesPagination.pageNumber = event.page + 1;
    this.solicitacoesPagination.pageSize = event.rows;
    this.carregarSolicitacoesRenovacao();
  }

  onFiltroInstituicaoChange(event: any) {
    this.filtroInstituicaoEnsino = event.value || null;
    this.carregarSolicitacoesRenovacao();
  }
  onFiltroEmpresaGestoraChange(event: any) {
    this.filtroEmpresaGestora = event.value || null;
    this.carregarSolicitacoesRenovacao();
  }

  verDetalhesSolicitacao(solicitacao: any) {
    // Lógica para ver detalhes
    this.messageService.add({
      severity: 'info',
      summary: 'Detalhes',
      detail: `Detalhes da solicitação ${solicitacao.id}`,
    });
  }
  validarSolicitacao(solicitacao: any) {
    // Lógica para validar solicitação
    this.messageService.add({
      severity: 'success',
      summary: 'Validação',
      detail: `Solicitação ${solicitacao.id} validada!`,
    });
  }
  // --- Fim da tabela de solicitações ---

  getInstituicoesEnsino() {
    this.instituicaoEnsinoService.list({ pageSize: 1000 }).subscribe((ret) => {
      this.instituicoesEnsino = ret.data;
      this.filters[0].options = this.instituicoesEnsino;
    });
  }
  getEmpresasGestoras() {
    this.instituicaoGestoraService
      .list({ pageSize: 1000, Activo: true })
      .subscribe((ret) => {
        this.empresasGestoras = ret.data ?? [];
        this.filters[1].options = this.empresasGestoras || ret.data || [];
      });
  }
  onActionSelected(event: any) {
    const { event: actionEvent, rowData } = event;
    this.solicitacoesActions
      .find((action) => action.label === actionEvent.item.label)
      ?.command?.({ item: rowData });
  }

  // --- Restante do componente permanece igual ---
  onFileSelected(event: any, item: FileItem) {
    if (event.target.files.length > 0) {
      item.file = event.target.files[0];
      item.descricao = event.target.files[0].name;
    }
  }
  removeFile(item: FileItem) {
    item.file = undefined;
  }
  getBolsaInstituicaoCurso(bolsaId: number | undefined) {
    if (!bolsaId) return;
    this.bolsaInstCursoService
      .getAllBolsaInstituicaoCursoGet(
        undefined,
        undefined,
        'ID desc',
        bolsaId,
        undefined,
        undefined,
        undefined,
        EnumEstadoBolsaCurso.NUMBER_0,
      )
      .subscribe((result) => {
        if (result.data) {
          this.bolsaInstCursoRenovar = result.data[0];
          this.getMatricula(this.bolsaInstCursoRenovar.id);
        }
      });
  }
  getMatricula(bolsaInstCursoId: number | undefined) {
    if (!bolsaInstCursoId) return;
    this.matriculaService
      .getAllMatriculaGet(
        undefined,
        undefined,
        'ID desc',
        bolsaInstCursoId,
        undefined,
        EnumEstadoMatricula.NUMBER_0,
      )
      .subscribe((result) => {
        if (result.data) {
          this.matricula = result.data[0];
          this.estadoMatricula = this.matricula.estado;
        }
      });
  }
  getTipoAnexoRenovacao() {
    this.tipoAenexoRenovacaoService.list().subscribe((retorno: any) => {
      if (retorno) {
        this.listaAnexos = retorno.map((item: any) => ({
          tipoAnexoRenovacaoID: item.id,
          descricao: item.designacao,
          required: item.obrigatorio,
        }));
      }
    });
  }
  getEstadoMatriculaEnum() {
    this.enumService
      .apiEnumsGetAllEstadoMatriculaEnumGet()
      .subscribe((retorno) => {
        this.listaEstados = Object.entries(retorno.data).map(
          ([key, value]) => ({
            id: Number(key) as EnumEstadoMatricula,
            designacao: value as string,
          }),
        );
      });
  }
  solicitarRenovacao() {
    if (!this.bolsaInstCursoRenovar || !this.matricula) {
      return;
    }

    let solicitacao: any = {
      solicitacao: {
        idBolsa: this.bolsaInstCursoRenovar.bolsaID,
        data: new Date().toISOString(),
        userId: '00000000-0000-0000-0000-000000000000',
        idAnoLetivoAnterior: 1,
        idAnoLetivoAtivacao: 2,
        estado: EstadoSolicitacaoRenovacao.NUMBER_1,
        parecerInstituicao: EnumParecerSolicitacao.NUMBER_3,
        parecerMIREMPET: EnumParecerSolicitacao.NUMBER_3,
        extraDataJson: 'lçfolisjfld', //JSON.stringify(this.matricula),
      },
      anexos: this.listaAnexos.map((item) => ({
        tipoAnexoRenovacaoID: item.tipoAnexoRenovacaoID,
        descricao: item.descricao,
      })),
    };
    let files = this.listaAnexos
      .map((item) => item.file)
      .filter((file): file is File => file !== undefined);
    if (files.length != solicitacao.anexos.length) {
      return;
    }
    this.solicitacaoRenovacaoService
      .solicitacaoRenovacaoPost(JSON.stringify(solicitacao), files)
      .subscribe((result) => {
        if (result.data) {
          this.messageService.add({
            severity: 'success',
            summary: 'Sucesso',
            detail: 'Solicitação de renovação de bolsa emitida!',
            life: 3000,
          });
          this.router.navigate(['/bolsas/:id']);
        }
      });
  }
  ToggleDetails() {
    this.ViewDetails = !this.ViewDetails;
  }
  GotoRenoveBolse() {
    this.ShowDetails = false;
    this.ShowRenovar = true;
  }

  Return() {
    this.ShowDetails = true;
    this.ShowRenovar = false;
  }
}
